import { render } from "./serviceVue.vue?vue&type=template&id=5e66e8e2&lang=true"
import script from "./serviceVue.vue?vue&type=script&lang=js"
export * from "./serviceVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__